import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from 'src/app/global/global';

@Injectable({
  providedIn: 'root'
})
export class AvatarUploadServiceService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public uploadAvatar(file: File){
    let formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post(Global.BASE_API_URL + "/api/storage/", formData, {responseType: 'text'});
  }

}
